import React from 'react'

import { DataItem } from 'scrivito'

import { MyTeamCard } from '@/Atomic/Widgets/DataItemDetails/Contact/Details/MyTeamCard'
import { RelationalDataItemSublist } from '@/Atomic/Widgets/RelationalDataItemSublist'
import { SegmentFilter } from '@/Atomic/Widgets/SegmentFilter'
import { ContactSocialNetworkConnections } from '@/Components/EntityConnections/ContactSocialNetworkConnections'
import { DataClassName } from '@/Data/const'
import { RelationSublistConfigKey } from '@/utils/CRUD/read/relational/const'

interface LeftColumnProps {
  dataClassName: string
  dataItem: DataItem
}

export const LeftColumn: React.FC<LeftColumnProps> = ({
  dataClassName,
  dataItem,
}) => {
  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return (
        <>
          <RelationalDataItemSublist
            id={dataItem.id()}
            configKey={RelationSublistConfigKey.ACTIVITY_PERSON}
          />
          <RelationalDataItemSublist
            id={dataItem.id()}
            configKey={RelationSublistConfigKey.ACTIVITY_COMPANY}
          />
        </>
      )
    case DataClassName.COMPANY:
      return (
        <>
          <MyTeamCard id={dataItem.id()} />
          <ContactSocialNetworkConnections contactId={dataItem.id()} />
        </>
      )
    case DataClassName.DOCUMENT:
      return <></>
    case DataClassName.LEAD:
      return <></>
    case DataClassName.LIST:
      return <SegmentFilter.Modal />
    case DataClassName.OPPORTUNITY:
      return <></>
    case DataClassName.ORDER:
      return <></>
    case DataClassName.PERSON:
      return (
        <>
          <MyTeamCard id={dataItem.id()} />
          <ContactSocialNetworkConnections contactId={dataItem.id()} />
        </>
      )
    case DataClassName.QUOTE:
      return <></>
    case DataClassName.TICKET:
      return <></>
    default:
      console.warn(`No details left column found for ${dataClassName}`)
      return <></>
  }
}
